import React from 'react';
import ReactNotificationSystem from 'react-notification-system';

import notifier from '../../../services/ui/notifier';

const notificationStyle = {
    NotificationItem: {
        DefaultStyle: {
            fontSize: '15px',
            padding: '15px',
            borderRadius: '0',
            border: 'none',
            boxShadow: '0px 0px 5px 3px rgba(0,0,0,0.25)'
        },
        success: {
            backgroundColor: 'green',
            color: '#FFFFFF'
        },
        error: {
            backgroundColor: 'red',
            color: '#FFFFFF'
        }
    },
    Dismiss: {
        DefaultStyle: {
            display: 'none'
        }
    },
    Containers: {
        DefaultStyle: {
            marginTop: '75px'
        }
    }
};

export default class NotificationSystem extends React.Component {

    render() {
        return (
            <ReactNotificationSystem style={notificationStyle} ref={elem => notifier.setNotifierElement(elem)} />
        )
    }
}